import { render, staticRenderFns } from "./HeaderActions.vue?vue&type=template&id=7353ba7c&scoped=true&"
import script from "./HeaderActions.vue?vue&type=script&lang=js&"
export * from "./HeaderActions.vue?vue&type=script&lang=js&"
import style0 from "./HeaderActions.vue?vue&type=style&index=0&id=7353ba7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7353ba7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\src\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7353ba7c')) {
      api.createRecord('7353ba7c', component.options)
    } else {
      api.reload('7353ba7c', component.options)
    }
    module.hot.accept("./HeaderActions.vue?vue&type=template&id=7353ba7c&scoped=true&", function () {
      api.rerender('7353ba7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "BuildABox/components/HeaderActions.vue"
export default component.exports